import messageResource from '../../messageResource'

export default function PreviewSection() {}

PreviewSection.prototype.init = function ()
{
    return this;
};

PreviewSection.prototype.addRows = function ( tBody )
{
    // abstract
};

PreviewSection.prototype.addRow = function ( tBody, row )
{
    tBody.appendChild( row );
};

PreviewSection.prototype.createRow = function ( className )
{
    var tr = document.createElement( "tr" );
    if( className )
        tr.className = className;
    return tr;
};

PreviewSection.prototype.addCell = function ( row, innerHTML, className, colSpan, rowSpan )
{
    ReportPreviewUtils.addCell(row, innerHTML, className, colSpan, rowSpan);
};

PreviewSection.prototype.message = function ( key, params )
{
    return messageResource.getMessage( key, params );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/PreviewSection.js